import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { NPTEL } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/nptel/")({
  component: () => <DeptContentList cfg={NPTEL} />,
});
